// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLaptopOutlinedSvg from "@fishx/icons-svg/es/asn/PLaptopOutlined";
import FishxIcon from '../components/FishxIcon';

var PLaptopOutlined = function PLaptopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLaptopOutlinedSvg
  }));
};

PLaptopOutlined.displayName = 'PLaptopOutlined';
export default React.forwardRef(PLaptopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLaptopOutlined.js
// module id = 3478
// module chunks = 0